import {Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges} from '@angular/core';

type LoaderTheme = 'light' | 'default';

@Directive({
  selector: '[appDottedLoader]'
})
export class DottedLoaderDirective implements OnChanges {
  @Input()
  appShowLoaderUntil: any;
  @Input()
  loaderTheme: LoaderTheme = 'default';

  private readonly element: any;

  constructor(element: ElementRef, private renderer: Renderer2) {
    this.element = element.nativeElement;
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const detectedLoaderTheme = (this.loaderTheme === 'light') ? 'typing-loader-light' : 'typing-loader-default';

    if (this.appShowLoaderUntil === undefined || this.appShowLoaderUntil === null) {
      return this.renderer.addClass(this.element, detectedLoaderTheme);
    } else {
      return this.renderer.removeClass(this.element, detectedLoaderTheme);
    }
  }
}
